
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {LinaConstants} from '../../../shared/constants/constants';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable()
export class CompatibilityGuard implements CanActivate {

  constructor(private router: Router, private deviceDetector: DeviceDetectorService) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const deviceInfo = this.deviceDetector.getDeviceInfo();
    if (LinaConstants.blockedBrowsers[deviceInfo.browser.toLowerCase()] &&
      parseInt(deviceInfo.browser_version) < LinaConstants.blockedBrowsers[deviceInfo.browser.toLowerCase()]) {
      this.router.navigateByUrl('/misc/unsupportedbrowser');
      return false;
    } else {
      return true;
    }
  }
}
